module.exports = __webpack_public_path__ + "media/images/plans/dinner/occation-title-3-01eebde74a1cb8f2369b98ae1c979b53.png";